import React from 'react';
import { Money } from 'components/utilities';
import { EventRegistration } from 'resources';

class UnauthenticatedRegistrationConfirmation extends React.Component {

  state = {
    eventRegistration: {},
  }

  componentDidMount() {
    this.doObjectRetrieve();
  }

  objectQuery = `
    event_registration {
      email
      name
      amount
      tickets
      event {
        name
        description
      }
    }
  `
  doObjectRetrieve = () => {

    EventRegistration.retrievePublic({
      id: this.props.params.registration_id,
      query: this.objectQuery,
      onSuccess: ({ data }) => this.setState({
        eventRegistration: data,
      }),
    });
  }

  descriptionName = (name) => (
    `Greek Capita*${name.toLowerCase().replace(/\s+/g, '-')}`
  )

  renderPayedConfirmation = () => {
    const { eventRegistration } = this.state;
    const { event } = eventRegistration;

    const numTickets = _.get(eventRegistration, 'tickets') || 1;

    return (

      <div className="account-wrapper">
        <p className="account-wrapper m-t-2 m-b-neg-1"><br /></p>

        <div className="account-body m-t-2">
          <h3 className="text-success m-b-05">You{"'"}re registered!</h3>

          <p className="m-b-2 fs-125">
            {`You've purchased ${numTickets} ticket${numTickets !== 1 ? 's' : ''} to ${_.get(event, 'name')}.`}
          </p>

          <p className="m-b-0">
            <Money amount={_.get(eventRegistration, 'amount')} /> has been charged to your card.
          </p>
          <p className="text-muted">It will appear as <em>{ this.descriptionName(_.get(event, 'name')) }</em> on your statement
          </p>

          <p className="m-t-2 m-b-2">
            {`An email confirmation has been sent to ${_.get(eventRegistration, 'email')}` }
          </p>
        </div>
      </div>
    );
  };

  renderFreeConfirmation = () => {
    const { eventRegistration } = this.state;
    const { event } = eventRegistration;

    /** *******************/
    /* <p className="account-wrapper m-t-2 m-b-neg-1"><em>no tickets, no payment</em></p>*/
    /** *******************/

    return (
      <div className="account-wrapper">
        <p className="account-wrapper m-t-2 m-b-neg-1"><br /></p>

        <div className="account-body m-t-2">

          <h3 className="text-success m-b-05">You{"'"}re registered!</h3>

          <h5 className="m-b-1">
            { _.get(event, 'name') }
          </h5>

          <p className="m-t-2 m-b-2">
            {`An email confirmation has been sent to ${_.get(eventRegistration, 'email')}` }
          </p>
        </div>
      </div>
    );
  };

  render = () => {
    const { eventRegistration } = this.state;
    const { amount } = eventRegistration;

    if (_.isNil(eventRegistration.id)) {
      return null;
    }

    return (
      <div>
        { (amount > 0) ? this.renderPayedConfirmation() : this.renderFreeConfirmation() }
      </div>
    );
  }

}

export default UnauthenticatedRegistrationConfirmation;
